import React from 'react'

const Loader = () => {

    return (
        <div className="loader-wrap">
            <div className="pin"></div>
        </div>
    )
}

export default Loader
